import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import classes from "../Login/Login.module.css";
import VisitorClasses from "./VisitorPass.module.css";
import "../../../assets/css/visitor-css/master.css";
import moment from "moment";
import { QRCodeSVG } from 'qrcode.react';

const base_url = process.env.REACT_APP_BASE_URL;
const VisitorPass = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [logo, setLogo] = useState("");
  const [showQr, setShowQr] = useState(false);
  let Id;
  // let footerText1 = "";
  // let footerText2 = "";
  console.log(location.pathname);
  if (location.pathname.includes("digipass")) {
    Id = location.pathname.substring(10, location.pathname.length);
  } else if (location.pathname.includes("digiemppass")) {
    Id = location.pathname.substring(13, location.pathname.length);
  } else {
    
    Id = location.pathname.substring(6, location.pathname.length);
  }
  console.log(Id);

  const [didPass, setDigiPass] = useState({});
  const [footerText1, setfooterText1] = useState("");
  const [footerText2, setfooterText2] = useState("");
  const [domLoaded, setDomLoaded] = useState(false);
  const path = location.pathname;
  let showApprove = !/digi(pass|emppass)/.test(path);

  const [isDevToolsOpened, setIsDevToolsOpened] = useState(false);
  /*
  useEffect(() => {
    const handleResize = () => {
      if (window.outerHeight - window.innerHeight > 100) {
        setIsDevToolsOpened(true);
        alert("Dev tool opened");
      } else {
        setIsDevToolsOpened(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Check if dev tools are already open after the initial render
    if (window.outerHeight - window.innerHeight > 100) {
      setIsDevToolsOpened(true);
      console.log("Dev tool opened");
      alert("Dev tool opened");
    }

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  */

  const [qrValue, setQrValue] = useState(null);


  useEffect(() => {
    axios.get(`${base_url}/visitor/detail/${Id}`).then((res) => {
      const passData = res.data.data;
      setDigiPass(passData);
     // console.log("Digipass Data", passData);
      showApprove && passData.status !== "pending" && navigate('/approved-pass', { state: { status: passData.status } });
      // Check pass expiration
      const now = new Date();
      let isExpired = false;
      setQrValue(window.location.href); 
      if (passData.passType === 'PreBooking') {
        // For PreBooking, check createdFor date
        if (passData.createdForDate) {
          const passDate = new Date(passData.createdForDate);
          // Add one day
          const nextDay = new Date(passDate);
          nextDay.setDate(passDate.getDate() + 1);
        //  console.log(passDate +'----'+ now);
          isExpired = nextDay < now;
        }
      } else {
        // For normal passes, check created date
        if (passData.createdAt) {
          const passDate = new Date(passData.createdAt);
          // Check if pass is older than 1 day
          const oneDayInMs = 24 * 60 * 60 * 1000;
          isExpired = (now - passDate) > oneDayInMs || passData.checkedIn === false;
        }
      }
     // console.log(isExpired);

      //return;
      if (isExpired) {
        navigate('/expired-pass');
        return;
      }

      
      return axios(
        `${base_url}/visitor/company/details/${passData.companyId}`
      ).then((res) => {
        console.log("Company Data", res.data.data); 
        if(!location.pathname.includes("digiemppass")){
          setShowQr(res.data.data.boombarierQrCheck);
        }
        if (res.data.data.footerStatus) {
          setfooterText1(res.data.data.footerTextOne);
          setfooterText2(res.data.data.footerTextTwo);
        }
        setLogo(res.data.data.logo);
        setDomLoaded(true);
      });
    }).catch(error => {
      console.error("Error fetching pass details:", error);
      navigate('/expired-pass-visitor');
    });
  }, [Id, navigate]);

  const handleApproveReject = (status) => {
    let reqObj = {
      method: "POST",
      url: `${base_url}/visitor/emp-decision`,
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        visitorId: Id,
        status: status
      }
    };
    axios(reqObj)
      .then((res) => {
        navigate("/thank-you");
      })
      .catch((err) => {
        console.log(err);
      });
    // /visitor/end-meeting
    if (status == "rejected") {
      axios
        .put(`${base_url}/visitor/check-out/${Number(didPass.phone)}`, {
          checkedoutBy: `${didPass.empName}(Meeting person rejected.)`
        })
        .then((visitor) => {});
    }
  };

  console.log(didPass,"didPass");
  

  let showAccessories =
    didPass["isLaptop"] ||
    didPass["isMobile"] ||
    didPass["isHardDisk"] ||
    didPass["isCharger"] ||
    didPass["isOtherAccessory"];

  let showValidId = didPass["docFront"] || didPass["docBack"];

  return (
    <>
      {domLoaded && (
        <div className="wrapper-box z1 digipass-bg-color">
          <div className="container z2" style={{ position: "relative" }}>
            {/* <div className="app-panel"> */}
            {/* <div
              className="bg-special z3"
              style={{
                backgroundColor: "#003ca6"
              }}
            ></div> */}
            <div
              className="bg-special z3"
              style={{
                backgroundColor: "#003ca6",
                borderRadius: 0,
                height: "100%"
              }}
            ></div>
            <div className="bg-ellipes-left z3"></div>
            <div className="bg-ellipes-right z3"></div>
            <div className="wrapper-mid z4">
              <div className="logo-div">
                <img
                  src={require("../../../assets/img/visitor-images/images/logo.png")}
                />
              </div>
            
              <div className="text-logo">
                <h1>DigiPass</h1>
                <p style={{
                width: '150px',
                maxHeight:'65px',
                margin: '0 auto 0 auto',
                position: 'relative',
                paddingTop: '10px',
                paddingBottom: logo ? '10px' : '40px'
                
              }}>
                  {/* Visitor Management <br></br>System */}
                  VISITOR
                </p>
              </div>
              {logo && <div style={{
                width: '150px',
                margin: '0 auto 0 auto',
                position: 'relative',
                paddingTop: '10px',
                paddingBottom: '40px',
              }}>
                <img style={{
                  width: '80px',
                  margin: '0 auto',
                  display: 'block',
                  background:'#ffffff',
                  padding:'2px'
                }}
                  src={logo}
                />
              </div>}
              <div className="body-mid">
                <div className="event-div">
                  {didPass.selfie && (
                    <div className="pic-img">
                      <img src={didPass.selfie} />
                    </div>
                  )}
                  {!didPass.selfie && (
                    <div className="pic-img">
                      <img
                        src={require("../../../assets/img/visitor-images/mountain.png")}
                      />
                    </div>
                  )}
                  <div className="content">
                    <p>
                      <strong>{`${didPass.firstName} ${didPass.lastName}`}</strong>
                    </p>
                    <p>{didPass.phone}</p>
                    <p>{didPass.location}</p>
                  </div>
                </div>
                {showValidId && (
                  <div className="event-div">
                    <div className="content">
                      <p className="govtid">Valid ID -</p>
                    </div>
                    {didPass.docFront && (
                      <div className="pic-img">
                        <img src={didPass.docFront} />
                        <p>Front</p>
                      </div>
                    )}
                    <div className="space-div"></div>
                    {didPass.docBack && (
                      <div className="pic-img">
                        <img src={didPass.docBack} />
                        <p>Back</p>
                      </div>
                    )}
                  </div>
                )}
                <div className="event-div">
                  <p>
                    <label>Company Name</label>- {didPass.companyName}
                  </p>
                  <p>
                    <label>Meeting Person</label>- {didPass.empName}
                  </p>
                  <p>
                    <label>Pass Type</label>- Daily Pass
                  </p>
                  <p>
                    <label>Purpose of visit</label>- {didPass.purposeOfVisit}
                  </p>
                  <p>
                    <label>{didPass.createdForDate ? "Valid For" : "Valid Up to"}</label>-{" "}
                    {didPass.createdForDate ? didPass.createdForDate.substring(0, 10) : didPass.createdAt.substring(0, 10)}
                  </p>
                  <p>
                    <label>{didPass.createdForDate ? "Created For Date" : "Created Date"}</label>-{" "}
                    {/* {moment(didPass.otpSent).format("MMM D, hh:mm A")} */}
                    {/* {moment.utc(didPass.otpSent).format("MMM D, hh:mm A")} */}
                    {
                      didPass.createdForDate && didPass.createdForTime
                        ? moment(`${didPass.createdForDate}T${didPass.createdForTime}`).format("MMM D, hh:mm A")
                        : moment(didPass.createdAt).format("MMM D, hh:mm A")
                    }
                    {/* {moment(didPass.notifyUserSms).format("MMM D, hh:mm A")} */}
                    {/* {moment(didPass.createdAt).format("MMM D, hh:mm A")} */}
                  </p>
                  {didPass["cardNo"] && (
                    <p>
                      <label>Card No</label>- {didPass["cardNo"]}
                    </p>
                  )}

                  {showAccessories && (
                    <div>
                      <div className="accessories">Accessories</div>
                      {didPass["isLaptop"] && (
                        <p>
                          <label>Laptop</label>- {didPass["laptopSerial"]}
                        </p>
                      )}
                      {didPass["isMobile"] && (
                        <p>
                          <label>Mobile</label>- {didPass["mobileSerial"]}
                        </p>
                      )}
                      {didPass["isHardDisk"] && (
                        <p>
                          <label>Hard Disk</label>- {didPass["hardDiskSerial"]}
                        </p>
                      )}
                      {didPass["isCharger"] && (
                        <p>
                          <label>Charger</label>- {didPass["chargerSerial"]}
                        </p>
                      )}
                      {didPass["isOtherAccessory"] && (
                        <p>
                          <label>Other</label>-{" "}
                          {didPass["otherAccessorySerial"]}
                        </p>
                      )}
                    </div>
                  )}
                </div>

                                  {/* QR Code Section */}
               {!showApprove && showQr && <div style={{ 
                  textAlign: 'center', 
                  padding: '15px',
                  backgroundColor: '#fff',
                  margin: '15px 0',
                  borderRadius: '8px',
                  border: '1px solid #eee'
                }}>
                  <h3 style={{ margin: '0 0 10px 0', fontSize: '1rem' }}>Scan for Verification</h3>
                  {qrValue ? (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      padding: '10px',
                      backgroundColor: '#fff',
                      borderRadius: '4px',
                      margin: '0 auto',
                      maxWidth: '150px'
                    }}>
                      <QRCodeSVG
                        value={qrValue}
                        size={120}
                        level="H"
                        style={{
                          width: '100%',
                          height: 'auto',
                          maxWidth: '100%',
                          maxHeight: '100%'
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{
                      width: '120px',
                      height: '120px',
                      margin: '0 auto',
                      backgroundColor: '#f5f5f5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px'
                    }}>
                      Loading QR...
                    </div>
                  )}
                  <p style={{ fontSize: '0.7rem', color: '#666', margin: '8px 0 0' }}>
                    Scan this QR code for verification
                  </p>
                </div>}
                {showApprove && didPass.status == "pending" && (  
                  <div className="form-group">
                    <button
                      className="btn btn-danger reject-btn"
                      onClick={() => handleApproveReject("rejected")}
                    >
                      Reject
                    </button>
                    <button
                      className="btn btn-success success-btn"
                      onClick={() => handleApproveReject("approved")}
                    >
                      Approve
                    </button>
                  </div>
                )}
              </div>
              <footer
                className="visitor-pass-footer"
                style={{ backgroundColor: "transparent" }}
              >
                <p style={{ color: "#fff" }}>
                  {footerText1} <br></br> {footerText2}
                </p>
              </footer>
              {/* <Footer /> */}
            </div>
            {/* </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default VisitorPass;
